import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import pathnames from "routes/pathnames";

import api from "services/api";

import getQueryParams from "common/get-query-params";
import encodeQueryParams from "common/encode-query-params";
import serveRequestErrors from "common/serve-request-errors";

import ErrorResponseDto from "dto/services/error-response-dto";
import PagePopupAdsDto, { PagePopupAdsTableQueryParamsDto } from "dto/pages/popup-ads/page-popup-ads-dto";

import Button from "components/app-button";
import AppHeading from "components/app-heading";
import AppPopupAdsTable from "components/pages/popup-ads/app-popup-ads-table";

const PagePopupAdsListing = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [ads, setAds] = useState<PagePopupAdsDto>();
	const [isFetching, setIsFetching] = useState(false);
	const memoSetSearchParams = useRef(setSearchParams);
	const queryParams = useRef(getQueryParams<PagePopupAdsTableQueryParamsDto>(searchParams, { page: 0 }));

	const onHandleGetArticles = useCallback(async () => {
		setIsFetching(true);

		try {
			const { page } = queryParams.current;

			const payload = { size: 10, page };

			const response = await api.get.announcement.announcements(payload);

			setAds(response.data?.data?.list);
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		} finally {
			setIsFetching(false);
		}
	}, []);

	//prettier-ignore
	const handlePageChange = useCallback((page: number) => {
        queryParams.current.page = page;

        memoSetSearchParams.current(encodeQueryParams(queryParams.current));

        onHandleGetArticles();
    }, [onHandleGetArticles]);

	const navigateToAddNew = useCallback(() => {
		navigate(`${pathnames.popupAdsDetails}create`);
	}, [navigate]);

	useEffect(() => {
		onHandleGetArticles();
	}, [onHandleGetArticles]);

	return (
		<div className="page-popup-ads-list">
			<div className="ads-list">
				<AppHeading title="Pop-up Ads">
					<AppHeading.Divider />
				</AppHeading>

				<div className="ads-list__button-container">
					<Button label="Add New" onClick={navigateToAddNew} />
				</div>

				{/* prettier-ignore */}
				<AppPopupAdsTable ads={ads?.content || []} onPageChange={handlePageChange} fetching={isFetching} paginationTable={{ currentPage: ads?.number || 0, totalPages: ads?.totalPages || 0, totalElements: ads?.totalElements || 0, numberOfElements: ads?.numberOfElements || 0, tableSize: ads?.size || 10 }} />
			</div>
		</div>
	);
};

export default PagePopupAdsListing;
